import React from "react";

/** Tiny SVG-style payment brand badges used in the marketing footer. */
const BRAND_BADGES = {
  visa: { label: "VISA", style: { color: "#1A1F71", background: "#fff" } },
  mastercard: {
    label: "MC", style: {
      color: "#fff",
      background: "linear-gradient(90deg, #EB001B 0 50%, #F79E1B 50% 100%)",
    }
  },
  amex: { label: "AMEX", style: { color: "#fff", background: "#2E77BB" } },
  upi: { label: "UPI", style: { color: "#fff", background: "linear-gradient(135deg,#097939,#ED752E)" } },
  wallet: { label: "Wallet", style: { color: "#fff", background: "#0F172A" } },
  netbanking: { label: "Net Banking", style: { color: "#0F172A", background: "#E2E8F0" } },
  rupay: { label: "RuPay", style: { color: "#fff", background: "linear-gradient(90deg,#28a745,#138808)" } },
  paypal: { label: "PayPal", style: { color: "#fff", background: "#003087" } },
};

export default function PaymentBadges({ brands = [], processorText = "", logos = {} }) {
  if (!brands?.length) return null;
  return (
    <div className="mt-6 flex flex-wrap items-center gap-3" data-testid="accepted-payments">
      <span className="text-[11px] uppercase tracking-[0.22em] text-slate-500">We Accept</span>
      <div className="flex flex-wrap items-center gap-2">
        {brands.map((b) => {
          const customLogo = logos?.[b];
          if (customLogo) {
            return (
              <span
                key={b}
                data-testid={`pay-brand-${b}`}
                className="inline-flex items-center bg-white rounded-md overflow-hidden"
                style={{ height: 26, padding: "0 8px", boxShadow: "0 1px 2px rgba(0,0,0,0.4)" }}
                title={b}
              >
                <img src={customLogo} alt={b} style={{ height: 18, width: "auto", display: "block" }} />
              </span>
            );
          }
          const cfg = BRAND_BADGES[b] || { label: b, style: { color: "#fff", background: "#475569" } };
          return (
            <span
              key={b}
              data-testid={`pay-brand-${b}`}
              style={{
                ...cfg.style,
                fontFamily: "Outfit, sans-serif",
                fontWeight: 800,
                fontSize: 11,
                letterSpacing: "0.04em",
                padding: "6px 10px",
                borderRadius: 6,
                lineHeight: 1,
                display: "inline-flex",
                alignItems: "center",
                boxShadow: "0 1px 2px rgba(0,0,0,0.4)",
              }}
            >
              {cfg.label}
            </span>
          );
        })}
      </div>
      {processorText && (
        <span className="text-[11px] text-slate-400 ml-2 hidden sm:inline" data-testid="payment-processor-text">
          {processorText}
        </span>
      )}
    </div>
  );
}
